// Shared design tokens for "The Clinical Sanctuary" aesthetic.
// Keep inline-style usage consistent across dashboard components.

export const CLINIC_COLORS = {
  primary: "#00658D",
  primaryLight: "#00AEEF",
  ink: "#0c2d4a",       // Deep headline
  body: "#181c20",
  muted: "#3e4850",
  subtle: "#6e7881",
  placeholder: "#94a3b8",
  divider: "#dfe3e8",
  ghost: "rgba(189,200,209,0.3)", // 30% ghost border
  ghostFocus: "#00658D",
  surfaceHighest: "#f1f4f9",
  warmAmberBg: "rgba(141,79,0,0.08)",
  warmAmber: "#6d3a00",
};

export const BTN_GRADIENT = "linear-gradient(180deg, #00aeef 0%, #00658d 100%)";
export const CLINICAL_SHADOW = "0 4px 20px rgba(0,101,141,0.06)";
export const CLINICAL_CARD = {
  background: "#fff",
  borderRadius: "24px",
  boxShadow: CLINICAL_SHADOW,
  border: "1px solid rgba(189,200,209,0.15)",
};
